(function ($) {
    $(document).ready(function () {
        const enterManuallyLink = '#health-address-LinkText';

        $('#postcode-lookup-address').hide();
        $(enterManuallyLink).on('click',function() {
            $('#address-auto-dropdown').hide();
            $('#postcode-lookup-address').show();
        });
    });
})(window.jQuery);

if (window.location.pathname === '/my-account/details/phone/health' && window.sessionStorage.MemberPhone) {
    let PersonalisedData = JSON.parse(window.sessionStorage.MemberPhone);
    $('#plan-number').text(PersonalisedData.PlanNumber);
    for (let i = 0; i < PersonalisedData.PlanPhoneDetails.length; i++) {
        if (PersonalisedData.PlanPhoneDetails[i].TelephoneType === 'H') {
            $('#home-number').val(PersonalisedData.PlanPhoneDetails[i].PhoneNumber);
            if (PersonalisedData.PlanPhoneDetails[i].InternationalDialCode === '44') {
                $('#home-number-region').val('+' + PersonalisedData.PlanPhoneDetails[i].InternationalDialCode);
            }
            else {
                $('#home-number-region').val(PersonalisedData.PlanPhoneDetails[i].InternationalDialCode);
            }
        }
        if (PersonalisedData.PlanPhoneDetails[i].TelephoneType === 'W') {
            $('#work-number').val(PersonalisedData.PlanPhoneDetails[i].PhoneNumber);
            if (PersonalisedData.PlanPhoneDetails[i].InternationalDialCode === '44') {
                $('#work-number-region').val('+' + PersonalisedData.PlanPhoneDetails[i].InternationalDialCode);
            }
            else {
                $('#work-number-region').val(PersonalisedData.PlanPhoneDetails[i].InternationalDialCode);
            }
        }
        if (PersonalisedData.PlanPhoneDetails[i].TelephoneType === 'M') {
            $('#mobile-number').val(PersonalisedData.PlanPhoneDetails[i].PhoneNumber);
            if (PersonalisedData.PlanPhoneDetails[i].InternationalDialCode === '44') {
                $('#mobile-number-region').val('+' + PersonalisedData.PlanPhoneDetails[i].InternationalDialCode);
            }
            else {
                $('#mobile-number-region').val(PersonalisedData.PlanPhoneDetails[i].InternationalDialCode);
            }
        }
    }
}
if (window.location.pathname === '/my-account/details/phone/health' && !window.sessionStorage.MemberPhone) {
    window.location.replace('/my-account/details/phone');
}
